import React from 'react'
import { css } from '@emotion/core'
import { bpMaxSM } from '~lib/breakpoints'

const Container = React.forwardRef((props, ref) => {
  const {
    maxWidth = 940,
    noHorizontalPadding = false,
    noVerticalPadding = false,
    smallVerticalPadding = false,
    ...restProps
  } = props
  return (
    <div
      ref={ref}
      css={css`
        width: 100%;
        margin: 0 auto;
        max-width: ${maxWidth + (noHorizontalPadding ? 0 : 80)}px;
        padding: ${noVerticalPadding ? 0 : smallVerticalPadding ? '20' : '40'}px ${noHorizontalPadding ? 0 : '40'}px;
        ${bpMaxSM} {
          padding: ${noVerticalPadding ? 0 : smallVerticalPadding ? '10' : '20'}px ${noHorizontalPadding ? 0 : '20'}px;
        }
      `}
      {...restProps}
    >
      {props.children}
    </div>
  )
})

export default Container
